<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M340.001-238.387v-487.687l383.073 243.843-383.073 243.844Zm45.384-243.844Zm0 161 253.999-161L385.385-643.23v321.999Z"/></svg>
</template>
